/**
 * Brand Check Service
 *
 * API service for Brand Check feature - visual consistency checking tool
 */

import api from './api';
import {
  BrandCheckCalendarResponse,
  BrandCheckChannelResponse,
  BrandCheckSort,
  BrandCheckStatus,
} from '@/types/brand-check';

interface CalendarParams {
  calendarIds: number[];
  channelIds?: number[];  // Optional cross-filter: only show posts targeting these channels
  status?: BrandCheckStatus;
  sort?: BrandCheckSort;
  search?: string;
  cursor?: string;
  limit?: number;
}

interface ChannelParams {
  channelIds: number[];
  calendarIds?: number[];  // Optional cross-filter: only show posts from these calendars
  status?: BrandCheckStatus;
  sort?: BrandCheckSort;
  search?: string;
  cursor?: string;
  limit?: number;
}

export const brandCheckService = {
  /**
   * Get brand check items by calendar(s)
   * For Calendar View - see how posts for specific calendars look together
   */
  getByCalendar: async (params: CalendarParams): Promise<BrandCheckCalendarResponse> => {
    const queryParams = new URLSearchParams();
    queryParams.set('calendarIds', params.calendarIds.join(','));
    if (params.channelIds?.length) queryParams.set('channelIds', params.channelIds.join(','));
    if (params.status) queryParams.set('status', params.status);
    if (params.sort) queryParams.set('sort', params.sort);
    if (params.search) queryParams.set('search', params.search);
    if (params.cursor) queryParams.set('cursor', params.cursor);
    if (params.limit) queryParams.set('limit', String(params.limit));

    const { data } = await api.get(`/api/brand-check/calendar?${queryParams}`);
    return data.data;
  },

  /**
   * Get brand check items by channel(s)
   * For Channel View - see how feed will look on specific platform(s)
   */
  getByChannel: async (params: ChannelParams): Promise<BrandCheckChannelResponse> => {
    const queryParams = new URLSearchParams();
    queryParams.set('channelIds', params.channelIds.join(','));
    if (params.calendarIds?.length) queryParams.set('calendarIds', params.calendarIds.join(','));
    if (params.status) queryParams.set('status', params.status);
    if (params.sort) queryParams.set('sort', params.sort);
    if (params.search) queryParams.set('search', params.search);
    if (params.cursor) queryParams.set('cursor', params.cursor);
    if (params.limit) queryParams.set('limit', String(params.limit));

    const { data } = await api.get(`/api/brand-check/channel?${queryParams}`);
    return data.data;
  },
};
